export enum ROUTES {
  LOGIN = "/",
  MANUALUPLOAD = "/paymentsolution/manual-upload",
  NTF = "*",
  REPORTS = "/paymentsolution/reports",
  REPROCESS = "/paymentsolution/reprocess",
  PATCHNOTE = "/paymentsolution/patchnote",
  PROFILE = "/paymentsolution/profile",
  PROFILESECTION = "/paymentsolution/profile/:section",
  TRACK = "/paymentsolution/track",
  APPROVE = "/paymentsolution/approve",
  INBOXNOTIFICATION = "/paymentsolution/inbox-notification",
}
